/* eslint-disable array-callback-return, consistent-return */
import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Image from '../../../../shared/components/Image';
import { DEFAULT_IMAGE_URLS, SEGMENT_EVENTS } from '../../../../shared/Constants';
import MyPathwayMilestoneRow from './MyPathwayMilestoneRow';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

const MyPathwayMilestones = ({
    pathwayToDisplay,
    loggedInUserCompany,
    isVerbAdmin,
    toggleCalendarModal,
    collectionsById,
    userCollectionsById,
    upNext,
    getEventHref,
    markTaskAsCompleted,
    updateUserPathwayContentItem,
    setModalLoadingOverlay,
    updateUserPathway
}) => {
    const config = useContext(RuntimeContext)
    const contentArray = [];

    (pathwayToDisplay?.content || []).forEach((col, idx) => {
        const isEvent = col.type === 'EVENT';
        const isTask = col.type === 'TASK';

        if (isEvent || isTask) {
            const milestone = col || {};

            const viewMilestoneURL = () => {
                if (!milestone.urlLink) {
                    return;
                }
                const href = getEventHref(milestone);
                return window.open(href);
            };
            let milestoneIconImage = (
                <Image
                    src={DEFAULT_IMAGE_URLS.PATHWAY_EVENT_FLAG}
                    className={'pathway-event-flag'}
                    dimension={{ h: 43, w: 45 }}
                    cloudinaryCrop={'fill'}
                    quality={{ q: 100 }}
                />
            );
            let dateTimeFormat = 'M/D @h:mma';

            dateTimeFormat = 'M/D';
            if (isTask) {
                milestoneIconImage = (
                    <Image
                        src={
                            milestone.isCompleted
                                ? DEFAULT_IMAGE_URLS.PATHWAY_TASK_COMPLETE
                                : DEFAULT_IMAGE_URLS.PATHWAY_TASK_INCOMPLETE
                        }
                        className={'pathway-event-flag'}
                        dimension={{ h: 48, w: 48 }}
                        cloudinaryCrop={'fill'}
                        quality={{ q: 100 }}
                    />
                );
            }
            const taskDetailClick = updateUserPathway
                ? () => markTaskAsCompleted(idx, milestone)
                : () => {
                      setModalLoadingOverlay(true);
                      return updateUserPathwayContentItem(milestone, idx).then(() => {
                          setModalLoadingOverlay(false);
                      });
                  };
            const taskCompleteDetail = (
                <div className={`col-12 task-checkbox-detail`} onClick={taskDetailClick}>
                    <div
                        className={`task-square ${
                            milestone.isCompleted ? 'task-square-completed' : ''
                        } meta-icon-size meta-vertical-align`}
                    >
                        <div className={'task-square--content'} />
                    </div>
                    <span className={'meta-vertical-align meta-space'}>
                        {milestone.isCompleted ? 'COMPLETED' : 'MARK AS COMPLETE'}
                    </span>
                </div>
            );

            let dateTimeDetail;
            const milestoneDueDate = milestone.dateTime || milestone.dueDate;
            if (milestoneDueDate) {
                const formattedDateTime = moment(milestoneDueDate).format(dateTimeFormat);
                dateTimeDetail = (
                    <div className={'col-7 event-date-time-info'} onClick={() => toggleCalendarModal(milestone)}>
                        <i className={'fal fa-calendar-alt meta-icon-size meta-vertical-align'} />
                        <span className={'meta-vertical-align meta-space'}>
                            {isTask ? 'DUE ' : ''}
                            {formattedDateTime.toUpperCase()}
                        </span>
                    </div>
                );
            }

            let urlLinkDetail;

            if (milestone.urlLink) {
                const href = getEventHref(milestone);

                urlLinkDetail = (
                    <div
                        className={`${dateTimeDetail ? 'col-5' : 'col-12'} external-link-detail`}
                        onClick={() => window.open(href)}
                    >
                        <i className={'fal fa-external-link-alt meta-icon-size meta-vertical-align'} />
                        <span className={'meta-vertical-align meta-space'}>
                            {milestone.urlCustomName ? milestone.urlCustomName : 'OPEN LINK'}
                        </span>
                    </div>
                );
            }

            milestone.subtitle = milestone.shortDescription;

            contentArray.push(
                <MyPathwayMilestoneRow
                    key={`${milestone.name}-${milestoneDueDate}`}
                    milestone={milestone}
                    details={{
                        primaryDetail: null,
                        secondaryDetail: null,
                        dateTimeDetail,
                        urlLinkDetail,
                        taskCompleteDetail
                    }}
                    titleClick={viewMilestoneURL}
                    iconImage={milestoneIconImage}
                    insertEvent
                    isFirstRow={idx === 0}
                />
            );
        } else {
            let dateTimeDetail = null;
            let primaryDetail = null;
            let secondaryDetail = null;
            const collection = {
                ...collectionsById[col.parentId || col.id],
                ...(col.dueDate ? { dueDate: col.dueDate } : {})
            };
            const userCollection = userCollectionsById[col.userSubscriptionId] || {};
            let iconImage = (
                <Image
                    src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_FLAG}
                    className={'herbie-flag'}
                    cloudinaryCrop={'fill'}
                    quality={{ q: 100 }}
                />
            );

            if (collection) {
                if (collection.dueDate) {
                    const formattedDateTime = moment(collection.dueDate).utc().format('MM/DD');
                    dateTimeDetail = (
                        <div className={'col-12 collection-due-date'}>
                            <i className={'fal fa-calendar-alt meta-icon-size meta-vertical-align'} />
                            <span className={'meta-vertical-align meta-space'}>
                                DUE {formattedDateTime.toUpperCase()}
                            </span>
                        </div>
                    );
                }
                if (collection.durationInMinutes || collection.totalTimeForCollection) {
                    const collectionTime = collection.durationInMinutes || collection.totalTimeForCollection;
                    const collectionText =
                        collectionTime < 60 ? `${collectionTime} MINS` : `${Math.round(collectionTime / 60)} HRS`;
                    primaryDetail = (
                        <div className={'col-6 collection-time'}>
                            <i className={'fal fa-clock meta-icon-size meta-vertical-align'} />
                            <span className={'meta-vertical-align meta-space'}>{collectionText}</span>
                        </div>
                    );
                }
                if (collection.content || collection.contentIds) {
                    const collectionCount = collection.content
                        ? collection.content.length
                        : collection.contentIds.length;
                    secondaryDetail = (
                        <div className={'col-6 collection-activities'}>
                            <i className={'fal fa-book meta-icon-size meta-vertical-align'} />
                            <span className={'meta-vertical-align meta-space'}>
                                {collectionCount === 1 ? '1 ACTIVITY' : `${collectionCount} ACTIVITIES`}
                            </span>
                        </div>
                    );
                }

                if (
                    userCollection &&
                    upNext._id &&
                    (userCollection._id === upNext._id || userCollection.collectionId === upNext._id)
                ) {
                    iconImage = (
                        <Image
                            src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_HERBIE_FLAG}
                            className={'herbie-holding-flag'}
                            cloudinaryCrop={'fill'}
                            quality={{ q: 100 }}
                        />
                    );
                }

                if (userCollection && userCollection.status === 'COMPLETED') {
                    iconImage = (
                        <Image
                            src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_FLAG_FILLED}
                            className={'herbie-flag-complete'}
                            cloudinaryCrop={'fill'}
                            quality={{ q: 100 }}
                        />
                    );
                }

                contentArray.push(
                    <MyPathwayMilestoneRow
                        key={userCollection._id || collection._id}
                        milestone={collection}
                        details={{ dateTimeDetail, primaryDetail, secondaryDetail }}
                        titleClick={() => {
                            return true;
                        }}
                        iconImage={iconImage}
                        insertEvent={false}
                        isFirstRow={idx === 0}
                    />
                );
            }
        }
    });
    return <div className={'my-pathway-milestones'}>{contentArray}</div>;
};

MyPathwayMilestones.propTypes = {
    pathwayToDisplay: PropTypes.object,
    loggedInUserCompany: PropTypes.object,
    isVerbAdmin: PropTypes.bool,
    toggleCalendarModal: PropTypes.func,
    collectionsById: PropTypes.object,
    userCollectionsById: PropTypes.object,
    upNext: PropTypes.object,
    getEventHref: PropTypes.func,
    markTaskAsCompleted: PropTypes.func,
    updateUserPathwayContentItem: PropTypes.func,
    setModalLoadingOverlay: PropTypes.func,
    updateUserPathway: PropTypes.func
};

export default MyPathwayMilestones;
